<template>
    <div class="py-qt">
        <h3 class="mb-0">
            <a :href="'#' + controls" class="btn-collapse-toggle no-decoration unpad-l" :class="{'is-expanded': open}" role="button" :aria-expanded="open ? 'true' : 'false'" :aria-controls="controls" @click.prevent="$emit('toggle')">
                <span class="btn btn-icon">
                    <i aria-hidden="true" class="fas fa-chevron-right"></i>
                </span>
                <span class="text-dark unpad-l">
                    <slot/>
                </span>
            </a>
        </h3>
    </div>
</template>

<script>
// Heading of one login-page accordion section; the page keeps which one is open
export default {
    props: {
        open: {type: Boolean, default: false},
        controls: {type: String, required: true},
    },
    emits: ['toggle'],
}
</script>
